// extracted by mini-css-extract-plugin
export var discard = "_2k-3";
export var muiTooltipTooltip = "_2k-5";
export var notificationBar = "_2k-2";
export var saveButtonHoverSlotWrapper = "_2k-4";
export var show = "_2k-1";
export var spacer = "_2k-0";